import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
  equipment?: string;
}

interface ActivityPhotoItem {
  image: string;
  alt: string;
}

interface MouItem {
  sno: number;
  organization: string;
  date: string;
  purpose: string;
}

interface PlacementItem {
  sno: number;
  branch: string;
  studentName: string;
  organization: string;
  designation: string;
}

interface IndustrialVisitItem {
  title: string;
  image: string;
  description: string;
}

interface ValueAddedCourseItem {
  sno: number;
  courseName: string;
  duration: string;
  companyName: string;
}

interface AlumniItem {
  image: string;
  alt: string;
  batch: string;
  name: string;
  designation: string;
  organization: string;
  location?: string;
}

interface AchievementItem {
  sno: number;
  branch: string;
  studentNames: string[];
  eventDate: string;
  eventName: string;
  collegeName: string;
  awardName: string;
}

interface NptelRecordItem {
  staffName: string;
  subject: string;
  grade: string;
}

interface ConferenceItem {
  sno: number;
  conferenceName: string;
  paperTitle: string;
  authors: string[];
  collegeName: string;
  date: string;
}

interface ResearchScholarItem {
  sno: number;
  staffName: string;
  domain: string;
}

interface ResearchPublicationItem {
  sno: number;
  staffName: string;
  paperTitle: string;
  publicationDetails: string;
}

interface PatentItem {
  sno: number;
  staffName: string;
  inventionTitle: string;
  applicationNumber: string;
  publicationDate: string;
}

interface ClubEventItem {
  sno: number;
  eventName: string;
  date: string;
  description: string;
}

interface IndustrialVisitRecordItem {
  sno: number;
  date: string;
  industry: string;
  studentsBenefitted: number;
}

@Component({
  selector: 'app-courses-grid-style-one-columns-two-page',
  templateUrl: './courses-grid-style-one-columns-two-page.component.html',
  styleUrls: ['./courses-grid-style-one-columns-two-page.component.scss']
})
export class CoursesGridStyleOneColumnsTwoPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Electronics & Communication Engineering';
  establishedYear = '2009';
  intake = '60 Students';
  contactEmail = 'hodece@fmcet.ac.in';

  admissionNotice =
    'Admissions open for 2026 : B.E (CIVIL), B.E (CSE), B.E (CSE - AI & ML), B.E (CSE - CS), B.E (ECE), B.E (EEE), B.E (MECH), MBA, M.E (CSE), M.E (Embedded System Technologies), M.E (Thermal Engineering).';

  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: "PEO's" },
    { id: 'tab4', label: 'POs & PSOs' },
    { id: 'tab14', label: 'Programme Offered' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Association & Club Activities' },
    { id: 'tab7', label: "MoU's" },
    { id: 'tab8', label: 'Placement Record' },
    { id: 'tab9', label: 'Industrial Visit' },
    { id: 'tab10', label: 'Value Added Courses' },
    { id: 'tab11', label: 'Alumni' },
    { id: 'tab12', label: 'Achievements' },
    { id: 'tab13', label: 'NPTEL' },
    { id: 'tab15', label: 'Research' }
  ];

  aboutParagraphs: string[] = [
    'The Department of Electronics and Communication Engineering was established in the year 2009 with a vision to develop competent professionals to meet the global challenges in modern engineering society.',
    'At present, it offers a 4-year B.E. Electronics and Communication Engineering programme with a sanctioned intake of 60 students.',
    'The laboratories are equipped with latest technology in the fields of Electronic Devices and Circuits, Digital Electronics, Linear Integrated Circuits, Microprocessors and Microcontrollers, Digital Signal Processing, Communication Systems, VLSI, Embedded Systems, Optical and Microwave, and advanced hardware and software environments.',
    'The department has a team of committed faculty members with sound knowledge in the areas of Applied Electronics, Communication Systems, Wireless Communication, Embedded Systems, Computer Communication, and Networking.'
  ];

  quickFacts: FactItem[] = [
    {
      title: 'Established',
      value: '2009'
    },
    {
      title: 'Intake',
      value: '60 Students'
    },
    {
      title: 'Academic Focus',
      value: 'Electronics, communication systems, embedded technologies, signal processing, VLSI, and networking'
    },
    {
      title: 'Department Strength',
      value: 'Committed faculty, modern laboratories, and strong orientation toward industry-relevant technologies'
    }
  ];

  visionText =
    'To produce Electronics and Communication Engineers capable of generating a knowledge economy with social responsibility.';

  missionPoints: string[] = [
    'To equip the students with the current trends and latest technologies in the field of Electronics and Communication Engineering to make them technically strong and ethically sound.',
    'To constantly motivate the students and faculty members to achieve excellence in Electronics and Communication Engineering and in Research and Development activities.',
    'To ideate and implement interdisciplinary projects and foster continuous learning in association with students and colleagues across disciplines of the institute and collaborate with academia, industries, organizations, and professional bodies for training, consultancy, and research.'
  ];

  peos: string[] = [
    'To provide the students with a strong foundation in the required sciences in order to pursue studies in Electronics and Communication Engineering.',
    'To gain adequate knowledge to become good professionals in electronics and communication engineering industries, higher education, and research.',
    'To develop attitude in lifelong learning, applying and adapting new ideas and technologies as the field evolves.',
    'To prepare students to critically analyze existing literature in an area of specialization and ethically develop innovative and research-oriented methodologies to solve identified problems.',
    'To inculcate in the students a professional and ethical attitude and an ability to visualize engineering issues in a broader social context.'
  ];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'Engineering Knowledge',
      description:
        'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.'
    },
    {
      title: 'Problem Analysis',
      description:
        'Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.'
    },
    {
      title: 'Design / Development of Solutions',
      description:
        'Design solutions for complex engineering problems and design system components or processes that meet specified needs with appropriate consideration for public health, safety, cultural, societal, and environmental considerations.'
    },
    {
      title: 'Conduct Investigations of Complex Problems',
      description:
        'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of information to provide valid conclusions.'
    },
    {
      title: 'Modern Tool Usage',
      description:
        'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of their limitations.'
    },
    {
      title: 'The Engineer and Society',
      description:
        'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.'
    },
    {
      title: 'Environment and Sustainability',
      description:
        'Understand the impact of professional engineering solutions in societal and environmental contexts, and demonstrate knowledge of and need for sustainable development.'
    },
    {
      title: 'Ethics',
      description:
        'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.'
    },
    {
      title: 'Individual and Teamwork',
      description:
        'Function effectively as an individual, and as a member or leader in diverse teams and multidisciplinary settings.'
    },
    {
      title: 'Communication',
      description:
        'Communicate effectively on complex engineering activities with the engineering community and society at large through reports, design documentation, presentations, and clear instructions.'
    },
    {
      title: 'Project Management and Finance',
      description:
        'Demonstrate knowledge and understanding of engineering and management principles and apply these to individual work and team-based project management in multidisciplinary environments.'
    },
    {
      title: 'Life-long Learning',
      description:
        'Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.'
    }
  ];

  programSpecificOutcomes: OutcomeItem[] = [
    {
      title: 'Electronic System Design',
      description:
        'Design, develop, and analyze electronic systems through application of relevant electronics, mathematics, and engineering principles.'
    },
    {
      title: 'Communication System Design',
      description:
        'Design, develop, and analyze communication systems through application of communication principles, signal processing, RF system design, and electromagnetics.'
    },
    {
      title: 'Adaptation to Emerging Technologies',
      description:
        'Adapt to emerging electronics and communication technologies and develop innovative solutions for existing and newer problems.'
    }
  ];

  programmes: ProgrammeItem[] = [
    {
      sno: 1,
      name: 'B.E. Electronics & Communication Engineering',
      duration: '4 Years'
    }
  ];

  labs: LabItem[] = [
    {
      title: 'Electronic Devices and Circuits Laboratory',
      image: 'assets/img/ece/lab1.jpeg',
      description:
        'This laboratory supports practical learning in semiconductor devices, diode and transistor characteristics, rectifiers, amplifiers, and basic electronic circuit applications.',
      equipment:
        'Diode and transistor trainer kits, CRO, function generators, regulated power supplies, and digital multimeters'
    },
    {
      title: 'Digital Electronics Laboratory',
      image: 'assets/img/ece/lab4.jpeg',
      description:
        'The lab provides hands-on training in logic gates, combinational and sequential circuits, flip-flops, counters, registers, and digital design fundamentals.',
      equipment:
        'Digital trainer kits, logic gate ICs, flip-flop and counter kits, breadboards, and testing instruments'
    },
    {
      title: 'Microprocessors and Microcontrollers Laboratory',
      image: 'assets/img/ece/lab3.jpeg',
      description:
        'This laboratory enables students to work with microprocessor and microcontroller programming, interfacing, embedded applications, and real-time hardware-based experiments.',
      equipment:
        '8086/8051 kits, Arduino and embedded boards, interfacing modules, keypad-display units, and power supply units'
    },
    {
      title: 'Communication Systems Laboratory',
      image: 'assets/img/ece/lab2.jpeg',
      description:
        'The laboratory offers exposure to analog and digital communication experiments including modulation, demodulation, signal analysis, and communication system performance studies.',
      equipment:
        'Communication trainer kits, signal generators, oscilloscopes, spectrum analysis support tools, and DSP experiment modules'
    }
  ];

  clubAcademicYear = '2024 - 2026';

  clubNames: string[] = ['ECE Association'];

  clubEvents: ClubEventItem[] = [
    {
      sno: 1,
      eventName: 'Guest Lecture – Linear Integrated Circuits',
      date: '24.05.2024',
      description:
        'The Guest Lecture on “Linear Integrated Circuits” by M. Shanmugam AP/ECE, Builders Engineering College, Tirpur, provides insights into the design and applications of analog ICs. It covers key concepts such as amplifiers, oscillators, and operational amplifier circuits.'
    },
    {
      sno: 2,
      eventName: 'Guest Lecture – Recent Trends in Satellite Communication Technology',
      date: '12.09.2024',
      description:
        'The Guest Lecture on “Recent Trends in Satellite Communication Technology” by Mr. S.D. Vijayakumar ASP/ECE, Builders Engineering College, Tirpur, provides insights into modern advancements in satellite-based communication systems.'
    },
    {
      sno: 3,
      eventName: 'Seminar on Embedded Systems',
      date: '18.09.2024',
      description:
        'The Seminar on “Embedded Systems” introduces the fundamentals of hardware–software integration in modern electronic devices. It covers microcontrollers, system design, and real-time applications by Mr. Arunkumar, ASP/EEE.'
    },
    {
      sno: 4,
      eventName: 'Association Inauguration',
      date: '06.11.2024',
      description:
        'The Association Inauguration marks the formal commencement of academic and technical activities for the department by Mr. A. Kesavan, CEO, Quantanics Techserv Pvt. Ltd., Madurai – 16.'
    },
    {
      sno: 5,
      eventName: 'Seminar - Advancement in Single Board Computers',
      date: '11.03.2025',
      description:
        'The Seminar on “Advancement in Single Board Computers” explores recent developments in compact and powerful computing platforms by Mr. Arunkumar, ASP/EEE.'
    },
    {
      sno: 6,
      eventName: 'Workshop on Embedded Systems & IoT',
      date: '21.04.2025',
      description:
        'The Workshop on “Embedded Systems & IoT” introduces the fundamentals of embedded hardware and Internet of Things technologies by Mr. Arunkumar, ASP/EEE.'
    },
    {
      sno: 7,
      eventName: 'Workshop – Altium Software for PCB Design',
      date: '11.08.2025 to 13.08.2025',
      description:
        'The workshop on “Altium Software for PCB Design” introduces participants to professional tools for designing and developing printed circuit boards by Mr. A. Kesavan, CEO, Quantanics Techserv Pvt. Ltd., Madurai – 16.'
    },
    {
      sno: 8,
      eventName: 'Guest Lecture on Software System Design',
      date: '02.09.2025',
      description:
        'The Guest Lecture on “Software Defined Network (SDN)” introduces the concept of separating the control and data planes in modern networking by Mrs. K. Rani Shanmugam AP/CSE, KLN College of Engineering & Technology, Madurai.'
    },
    {
      sno: 9,
      eventName: 'Seminar on Solar Symphony',
      date: '10.09.2025',
      description:
        'The Seminar on “Solar Symphony” explores the harmony and potential of solar energy as a sustainable power source by Mr. Sivakumar, Project Head, Green Solar Technology & Climate Tech Startup Company, Coimbatore.'
    },
    {
      sno: 10,
      eventName: 'Intra College Symposium – Axion’25',
      date: '15.09.2025',
      description:
        'The Intra College Symposium – Axion’25 is a dynamic platform for students to showcase their technical knowledge, creativity, and innovation. It features events such as paper presentations, technical quizzes, and project exhibitions across various domains.'
    },
    {
      sno: 11,
      eventName: 'Webinar – Career Pathways in Electronics: Fundamentals & Application',
      date: '30.01.2026',
      description:
        'The Webinar on “Career Pathways in Electronics: Fundamentals & Application” provides guidance on diverse career opportunities in the electronics field by Dr. K. Karuppasamy, Professor/ECE, Adithya Institute of Technology, Coimbatore.'
    },
    {
      sno: 12,
      eventName: 'Guest Lecture – Digital Signal Processing',
      date: '20.02.2026',
      description:
        'The Guest Lecture on “Digital Signal Processing” provides insights into the analysis and processing of digital signals by Dr. G. Mahendran, Professor/ECE, Syed Ammal Engineering College, Ramnad.'
    }
  ];

  clubActivityHighlight =
    'Association activities of the Department of Electronics & Communication Engineering.';

  clubActivityPhotos: ActivityPhotoItem[] = [];

  mous: MouItem[] = [
    {
      sno: 1,
      organization: 'Quantanics Techserv Pvt. Ltd.',
      date: '06.11.2024',
      purpose:
        'To provide practical exposure to real-time work environments and industry practices. To bridge the gap between academic knowledge and professional skills.'
    },
    {
      sno: 2,
      organization: 'Svasthi Technology Solutions',
      date: '03.09.2025',
      purpose:
        'To support students through training, mentoring, and structured growth opportunities, leading to improved performance and overall organizational progress.'
    },
    {
      sno: 3,
      organization: 'Silicon Harvest Technologies',
      date: '09.10.2025',
      purpose:
        'The internship programme provides students with practical exposure and hands-on experience aligned with industry requirements.'
    },
    {
      sno: 4,
      organization: 'Galwin Technology',
      date: '24.01.2025',
      purpose:
        'To develop technical, analytical, and problem-solving abilities among interns and familiarize interns with organizational structure, processes, and corporate culture.'
    }
  ];

  mouPhotos: ActivityPhotoItem[] = [
    {
      image: 'assets/img/ece/mou1.jpeg',
      alt: 'MoU signing with Svasthi Technology Solutions'
    },
    {
      image: 'assets/img/ece/mou2.jpeg',
      alt: 'MoU signing with Galwin Technology'
    }
  ];

  mouPhotoNotes: string[] = [
    'An MOU has been signed with Svasthi Technology, Trichy on 3rd September 2025, paving the way for advanced product development training and hands on skill enhancement for our students.',
    'An MOU has been signed with Quantanics Techserv Pvt. Ltd., Madurai on 6th November 2024, paving the bridge to bridge the gap between academic knowledge and professional skills for our students.',
    'An MOU has been signed with Galwin Technology, Madurai on 24th January 2025, paving the way to develop technical, analytical, and problem-solving abilities among interns for our students.'
  ];

  placements: PlacementItem[] = [
    { sno: 1, branch: 'ECE', studentName: 'VAIRA SELVAM V', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 2, branch: 'ECE', studentName: 'BHARATHVAJ M.E', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 3, branch: 'ECE', studentName: 'YUVARAJ P', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 4, branch: 'ECE', studentName: 'RAJASEKAR B', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 5, branch: 'ECE', studentName: 'SULAIMAN D', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 6, branch: 'ECE', studentName: 'SURYADEVASENATHYPATHY S', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 7, branch: 'ECE', studentName: 'MOHAMED ABUBAKKAR S', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 8, branch: 'ECE', studentName: 'DURGESH M', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 9, branch: 'ECE', studentName: 'HARISH KUMAR K', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 10, branch: 'ECE', studentName: 'THILAGAVATHI T', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 11, branch: 'ECE', studentName: 'ARAVIND K. G', organization: 'Prime Vector, Hosur', designation: 'S/W Trainee' },
    { sno: 12, branch: 'ECE', studentName: 'ALIYA FATIMA A', organization: 'Beasant Technologies', designation: 'Trainee' },
    { sno: 13, branch: 'ECE', studentName: 'ARUNKUMAR R', organization: 'Beasant Technologies', designation: 'Trainee' },
    { sno: 14, branch: 'ECE', studentName: 'HARISH KUMAR K', organization: 'Beasant Technologies', designation: 'Trainee' },
    { sno: 15, branch: 'ECE', studentName: 'RAJASEKAR B', organization: 'Beasant Technologies', designation: 'Trainee' },
    { sno: 16, branch: 'ECE', studentName: 'SULAIMAN D', organization: 'Beasant Technologies', designation: 'Trainee' },
    { sno: 17, branch: 'ECE', studentName: 'SURYADEVASENATHYPATHY S', organization: 'Beasant Technologies', designation: 'Trainee' },
    { sno: 18, branch: 'ECE', studentName: 'ALEXPANDIAN M', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 19, branch: 'ECE', studentName: 'ALIYA FATIMA A', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 20, branch: 'ECE', studentName: 'AMUTHAVAN N', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 21, branch: 'ECE', studentName: 'ARUNKUMAR R', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 22, branch: 'ECE', studentName: 'BHARATHVAJ M.E', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 23, branch: 'ECE', studentName: 'CHITHRA DEVI M', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 24, branch: 'ECE', studentName: 'DHAARANI M', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 25, branch: 'ECE', studentName: 'DURGESH M', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 26, branch: 'ECE', studentName: 'HARINI K', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 27, branch: 'ECE', studentName: 'HARISH KUMAR K', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 28, branch: 'ECE', studentName: 'IFRAN KHAN P', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 29, branch: 'ECE', studentName: 'JAMUNA RANI B', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 30, branch: 'ECE', studentName: 'KAVIPRIYA J', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 31, branch: 'ECE', studentName: 'MADESHKANNA S.B', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 32, branch: 'ECE', studentName: 'MATHEESWAR B', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 33, branch: 'ECE', studentName: 'MOHAMED ABUBAKKAR S', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 34, branch: 'ECE', studentName: 'MOHAMMED FAHAD N', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 35, branch: 'ECE', studentName: 'NARASIMMAN K', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 36, branch: 'ECE', studentName: 'PRADEEPA M', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 37, branch: 'ECE', studentName: 'RAJASEKAR B', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 38, branch: 'ECE', studentName: 'RESHMA O', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 39, branch: 'ECE', studentName: 'RIYA JASMINE N', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 40, branch: 'ECE', studentName: 'SANJINI V', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 41, branch: 'ECE', studentName: 'SANTHIYA S', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 42, branch: 'ECE', studentName: 'SULAIMAN D', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 43, branch: 'ECE', studentName: 'SURYADEVASENATHYPATHY S', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 44, branch: 'ECE', studentName: 'THILAGAVATHI T', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 45, branch: 'ECE', studentName: 'VAIRA SELVAM V', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 46, branch: 'ECE', studentName: 'VARSHA C', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 47, branch: 'ECE', studentName: 'VIJAYALAKSHMI V', organization: 'Delphi TVS, Chennai', designation: 'Trainee' },
    { sno: 48, branch: 'ECE', studentName: 'YUVARAJ P', organization: 'Delphi TVS, Chennai', designation: 'Trainee' }
  ];

  industrialVisits: IndustrialVisitItem[] = [
    {
      title: 'Visit to Parle-G',
      image: 'assets/img/eiv1.png',
      description:
        'An industrial visit to Parle-G provides students with an opportunity to observe and understand the production processes of one of India’s leading confectionery and biscuit manufacturers. Students can witness manufacturing, packaging, and quality control processes while gaining insights into operations, technology, and sustainability practices.'
    },
    {
      title: 'Visit to ISRO, Mahendragiri',
      image: 'assets/img/eiv2.png',
      description:
        'An industrial visit to the ISRO Propulsion Complex at Mahendragiri provides students with exposure to advanced rocket propulsion technologies, testing facilities, and space research activities, offering valuable insights into India’s space exploration initiatives.'
    },
    {
      title: 'Visit to Solar Observatory, Kodaikanal',
      image: 'assets/img/ece/iv3.jpeg',
      description:
        'An industrial visit to the Kodaikanal Solar Observatory provides students with an opportunity to observe and understand the scientific study of the Sun and its phenomena. Students can witness how solar observations are carried out using advanced instruments such as telescopes and spectrographs, while gaining insights into data collection, analysis, and research methodologies.'
    }
  ];

  industrialVisitRecords: IndustrialVisitRecordItem[] = [
    {
      sno: 1,
      date: '18.08.2023',
      industry: 'Patwari Bakers Pvt. Ltd',
      studentsBenefitted: 33
    },
    {
      sno: 2,
      date: '08.11.2024',
      industry: 'ISRO, Mahendragiri',
      studentsBenefitted: 33
    },
    {
      sno: 3,
      date: '07.05.2025',
      industry: 'Kodaikanal Observatory',
      studentsBenefitted: 33
    },
    {
      sno: 4,
      date: '19.02.2026',
      industry: 'Patwari Bakers Pvt. Ltd',
      studentsBenefitted: 28
    }
  ];

  valueAddedCourses: ValueAddedCourseItem[] = [
    {
      sno: 1,
      courseName: 'ECST25 - Sensor Technology (II-ECE)',
      duration: '03.03.2025 - 07.03.2025',
      companyName:
        'Introduce students to the principle of various transducers, their construction, applications, principles of operation, standards, and units of measurements.'
    },
    {
      sno: 2,
      courseName: 'ECRP25 - Raspberry Pi and Peripheral System (III-ECE)',
      duration: '03.03.2025 - 07.03.2025',
      companyName:
        'To design embedded systems using Raspberry Pi and related peripherals.'
    },
    {
      sno: 3,
      courseName: 'ECEAI26 - Embedded with AI-Automation',
      duration: '05.01.2026 - 09.01.2026',
      companyName:
        'To provide fundamental knowledge of embedded systems integrated with AI and automation technologies.'
    }
  ];

  valueAddedCoursePhotos: ActivityPhotoItem[] = [
    {
      image: 'assets/img/ece/vac1.jpeg',
      alt: 'Value Added Course Photo 1'
    },
    {
      image: 'assets/img/ece/vac3.jpeg',
      alt: 'Value Added Course Photo 2'
    }
  ];

  alumniRecords: AlumniItem[] = [


    {
      image: 'assets/img/ece/al3.jpeg',
      alt: 'Alumni - K. Pandikumar',
      batch: '2010-2013',
      name: 'K. Pandikumar',
      designation: 'Senior IT Analyst',
      organization: 'Honeywell',
      location: 'Madurai'
    },
    {
      image: 'assets/img/ece/al4.jpeg',
      alt: 'Alumni - G. Rajagopalan',
      batch: '2013-2017',
      name: 'G. Rajagopalan',
      designation: 'Managing Director',
      organization: 'Pragbees Info Tech',
      location: 'Madurai'
    },
    {
      image: 'assets/img/ece/al5.jpeg',
      alt: 'Alumni - N. Bhuvaneswaran',
      batch: '2010-2014',
      name: 'N. Bhuvaneswaran',
      designation: 'Managing Director',
      organization: 'Falcon Power and Controls Pvt. Ltd.',
      location: 'Chennai'
    },
    {
      image: 'assets/img/ece/al6.jpeg',
      alt: 'Alumni - S. Fedric Maria Kirubakaran',
      batch: '2010-2014',
      name: 'S. Fedric Maria Kirubakaran',
      designation: 'IT Analyst',
      organization: 'TCS',
      location: 'Canada'
    },
    {
      image: 'assets/img/ece/al7.jpeg',
      alt: 'Alumni - K. Ajay Kumar',
      batch: '2019-2023',
      name: 'K. Ajay Kumar',
      designation: 'Network Engineer',
      organization: 'Bharti Airtel Limited',
      location: 'Chennai'
    },
    {
      image: 'assets/img/ece/al8.jpeg',
      alt: 'Alumni - M. Gokila',
      batch: '2012-2016',
      name: 'M. Gokila',
      designation: 'Tech Lead',
      organization: 'Business Bay',
      location: 'Dubai'
    }
  ];

  achievements: AchievementItem[] = [
    {
      sno: 1,
      branch: 'III ECE',
      studentNames: ['J.Palraj', 'S.Ramesh', 'M.Ravi Chandran'],
      eventDate: '13.03.2026',
      eventName: 'Quiz Competition',
      collegeName: 'SBM College of Engineering and Technology',
      awardName: 'First Place'
    },
    {
      sno: 2,
      branch: 'III ECE',
      studentNames: ['J.Pragatheeswari'],
      eventDate: '06.03.2026',
      eventName: 'Group Dance',
      collegeName: 'Mangayarkarasi College of Engineering',
      awardName: '2nd Place'
    },
    {
      sno: 3,
      branch: 'III ECE',
      studentNames: ['M.Hari Krishnan', 'S.Ramesh', 'M.Ravi Chandran'],
      eventDate: '16.02.2026',
      eventName: 'IPL Auction',
      collegeName: 'Sourastra College, Madurai',
      awardName: 'First Place'
    },
    {
      sno: 4,
      branch: 'III ECE',
      studentNames: ['R.Varsha'],
      eventDate: '14.02.2026',
      eventName: 'Speech Competition',
      collegeName: 'SRM Institute of Science & Technology',
      awardName: 'Participation Certificate'
    },
    {
      sno: 5,
      branch: 'III ECE',
      studentNames: ['A.Kaviyarasu'],
      eventDate: '08.02.2026',
      eventName: 'Open Mr. South India',
      collegeName: 'Uplift Dynamics, Ramanathapuram',
      awardName: '9th Place in Senior 70 Kg'
    },
    {
      sno: 6,
      branch: 'III ECE',
      studentNames: ['V.Niranjan', 'S.Ramesh'],
      eventDate: '07.02.2026',
      eventName: 'Quiz Competition in Viyugam’26',
      collegeName: 'Solamalai Institutions, Madurai',
      awardName: '2nd Place'
    },
    {
      sno: 7,
      branch: 'II ECE',
      studentNames: ['M.S.Dharani Raj', 'Mohammed Aarif'],
      eventDate: '06.02.2026',
      eventName: 'Think-Link-Tech in Viyugam’26',
      collegeName: 'Solamalai Institutions, Madurai',
      awardName: '2nd Place'
    },
    {
      sno: 8,
      branch: 'II ECE',
      studentNames: ['M.S.Dharani Raj', 'Mohammed Aarif'],
      eventDate: '06.02.2026',
      eventName: 'Component Hurts in Viyugam’26',
      collegeName: 'Solamalai Institutions, Madurai',
      awardName: '2nd Place'
    },
    {
      sno: 9,
      branch: 'IV ECE',
      studentNames: ['Ms. A. Aliya Fathima', 'Ms. J. Kavipriya'],
      eventDate: '12.09.2025',
      eventName: 'Paper Presentation',
      collegeName: 'KLN College of Engineering, Sivagangai',
      awardName: 'First Prize'
    }
  ];

  achievementPhotos: ActivityPhotoItem[] = [
    {
      image: 'assets/img/ece/a1.jpeg',
      alt: 'ECE Achievement Photo 1'
    },
    {
      image: 'assets/img/ece/a2.jpeg',
      alt: 'ECE Achievement Photo 2'
    },
    {
      image: 'assets/img/ece/a3.jpeg',
      alt: 'ECE Achievement Photo 3'
    }
  ];

  achievementPhotoNotes: string[] = [
    'On 6th March 2026 J.Pragadeeswari Participated in the Event Group Dance Competition and Won 1st Prize at Mangayarkarasi College of Engineering.',
    'On 12th Sep 2025 Ms. A. Aliya Fathima and Ms. J. Kavipriya have won the first prize and received a cash award in the paper presentation competition organized by KLN College of Engineering, Sivagangai.',
    'On 8th February 2026 Mr. A. Kaviyarasu of III ECE has secured 9th place in the Senior Open Mr. South India - 2026 conducted by Indian Fitness Federation, Ramanathapuram.'
  ];

  nptelRecords: NptelRecordItem[] = [
    {
      staffName: 'Dr.K.R.Ramela',
      subject: 'Patent Drafting for Beginners',
      grade: 'Gold Elite'
    },
    {
      staffName: 'Dr.S.N.Nisharani',
      subject: 'Accrediation and Outcome Based Learning',
      grade: 'Silver Elite'
    },
    {
      staffName: 'Dr.S.N.Nisharani',
      subject: 'OBE and Accrediation',
      grade: 'Silver Elite'
    },
    {
      staffName: 'Mrs.P.Jebane',
      subject: 'OBE and Accrediation',
      grade: 'Silver Elite'
    },
    {
      staffName: 'Mr.M.Elayaraja',
      subject: 'OBE and Accrediation',
      grade: 'Elite'
    },
    {
      staffName: 'Mrs.R.Nagadeepa',
      subject: 'OBE and Accrediation',
      grade: 'Elite'
    }
  ];

  researchScholars: ResearchScholarItem[] = [
    {
      sno: 1,
      staffName: 'Mr.M.Elayaraja',
      domain: 'Wireless Sensor Networks'
    },
    {
      sno: 2,
      staffName: 'Mrs.R.Nagadeepa',
      domain: 'Image Processing'
    },
    {
      sno: 3,
      staffName: 'Mrs.S.Manisha Banu',
      domain: 'Medical Imaging Processing'
    }
  ];

  researchPublications: ResearchPublicationItem[] = [
    {
      sno: 1,
      staffName:
        'Dr. KR. Ramela, Prof/EEE; Dr. M. Valan Rajkumar, HoD/ECE; Ms. R. Nagadeepa, AP/ECE; Ms. P. Jebane, AP/ECE; Ms. A. Asiya Mariyam, AP/ECE; Ms. N. Thangalakshmi, AP/ECE',
      paperTitle:
        'Openness Recognition with Driver Drowsiness Detection (D3) Method Using Image Processing Applications',
      publicationDetails:
        'International Journal of Engineering and Computer\nISSN: 2319-7242, Vol. 15 No. 02, 2026'
    },
    {
      sno: 2,
      staffName:
        'Ms. P. Jebane, AP/ECE; Ms. R. Nagadeepa, AP/ECE; Mr. Elayaraja, ASP/ECE',
      paperTitle:
        'Smart Vehicle to Vehicle Communication System Using LI-FI',
      publicationDetails:
        'International Journal of Engineering and Techniques\nVolume 12, Issue 1, ISSN: 2395-13'
    },
    {
      sno: 3,
      staffName:
        'Dr. S. N. NishaRani, Prof/ECE; Ms. R. Nagadeepa, AP/ECE; Mrs. P. Jebane, AP/ECE; Mr. M. Elayaraja, AP/ECE',
      paperTitle:
        'A Two Stage Deep Learning Framework for Automated Glaucoma Detection Using U-NET & CNN Ensembles',
      publicationDetails:
        'International Journal of Electronics & Communication Engineering and Technology\nVolume 16, Issue 2\nISSN Print: 0976-6464 | ISSN Online: 0976-6472'
    },
    {
      sno: 4,
      staffName:
        'Dr. S. N. NishaRani, Prof/ECE; Ms. R. Nagadeepa, AP/ECE; Ms. A. Asiya Mariyam, AP/ECE; Ms. A. K. Palani Kumar, AP/ECE',
      paperTitle:
        'Waveform Performance in 5G Air Interface: A Comprehensive Review of Multicarrier Modulation Schemes',
      publicationDetails:
        "Journal of XI'AN University of Architecture and Technology\nVolume XVIII, Issue II, 2026"
    },
    {
      sno: 5,
      staffName:
        'Dr. S. N. NishaRani, Prof/ECE; Ms. R. Nagadeepa, AP/ECE; Mrs. P. Jebane, AP/ECE; Mr. C. Rajadurai, AP/ECE',
      paperTitle:
        'Image Processing Based Automated Smart Sericulture',
      publicationDetails:
        'Journal of Indian Institute of Industrial Engineering\nVolume 54, Issue 2, No. 1, February 2025'
    }
  ];

  patentRecords: PatentItem[] = [
    {
      sno: 1,
      staffName:
        'Dr. K. R. Ramela, Prof/EEE; Dr. S. N. NishaRani, Prof/ECE; Mr. M. Elayaraja, ASP/ECE; Mrs. P. Jebane, AP/ECE; Mrs. R. Nagadeepa, AP/ECE; Mrs. A. Asiya Mariyam, AP/ECE; Mrs. T. Saraniya, AP/ECE',
      inventionTitle:
        'Eco Friendly Device for Carbon-Di-Oxide Adsorption',
      applicationNumber: '436234-001',
      publicationDate: '31.10.2024'
    },
    {
      sno: 2,
      staffName:
        'Mr. M. Elayaraja, ASP/ECE; Mrs. R. Nagadeepa, AP/ECE; Mrs. P. Jebane, AP/ECE',
      inventionTitle:
        'Dynamic Resource Allocation for IoT Applications Through AI-Enabled Cloud Systems for Efficient Energy Management in Smart Homes',
      applicationNumber: '202441102917A',
      publicationDate: '25.12.2024'
    }
  ];

  conferenceRecords: ConferenceItem[] = [];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}